import {inProd} from '../private/private';

export const emailCaptureFlag = false;
export const footer = false;
export const amplitudeFlag = inProd ? true : false;